import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useReveal } from "@/lib/useReveal";

const FAQS = [
  {
    q: "Is this real money the government is holding for me?",
    a: "Yes. When property sells at a tax or foreclosure sale for more than what's owed, state law requires the surplus to be held by the county or court for the previous owner — or their heirs. It is your money. We help you claim it.",
  },
  {
    q: "What does it cost me?",
    a: "Nothing upfront. We work strictly on contingency — meaning we are only paid a percentage of what we successfully recover for you. If we recover nothing, you owe nothing.",
  },
  {
    q: "Could I do this on my own?",
    a: "Legally, yes. Practically, it involves locating the right court, drafting petitions, coordinating with clerks, proving identity and chain of title, and meeting strict statutory deadlines. Most claimants find the process opaque and time-consuming.",
  },
  {
    q: "How long does recovery take?",
    a: "Typical cases resolve in 60 to 180 days. Complex estates, heir disputes, or contested claims can take longer. We keep you informed at every step.",
  },
  {
    q: "How do I know you are legitimate?",
    a: "Lone Star Surplus Recovery LLC is a registered Texas company, licensed and bonded where required. We can provide our registration details, our written contract, and references on request. You sign no checks to us — funds are released to you directly.",
  },
  {
    q: "Will you ever ask for my Social Security Number over the phone?",
    a: "No. We only request sensitive identity information through secure, written channels after a signed engagement agreement. If anyone calls claiming to be us and pressures you for an SSN, hang up and call us directly at 817-680-2751.",
  },
  {
    q: "Which states and counties do you serve?",
    a: "We are headquartered in Texas and actively serve claims across multiple states and counties nationwide. Submit a claim check and we will confirm we can act on your behalf.",
  },
];

export const FAQ = () => {
  const ref = useReveal();
  return (
    <section
      id="faq"
      data-testid="faq-section"
      ref={ref}
      className="bg-[#FDFBF7] py-24 sm:py-32"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="reveal mb-12 text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#D4AF37]" />
            <span className="text-[#1E3A5F] text-xs uppercase tracking-[0.3em]">
              Answers
            </span>
            <span className="h-px w-10 bg-[#D4AF37]" />
          </div>
          <h2 className="font-serif-display text-[#0A192F] text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.05]">
            Questions,
            <br />
            <em className="italic text-[#1E3A5F]">answered plainly.</em>
          </h2>
        </div>

        <div className="reveal" style={{ transitionDelay: "120ms" }}>
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-[#E2DCD0]"
              >
                <AccordionTrigger className="font-serif-display text-left text-xl text-[#0A192F] hover:text-[#1E3A5F] py-6 hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#1E3A5F] text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
